module.exports = __webpack_public_path__ + "img/logo_corfo.6fb4ef6a.png";